// Formatea un número con separadores de miles y sin decimales
export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '$0';
  
  // Convierte a número entero (sin decimales)
  const intValue = Math.round(Number(value));
  
  // Agrega separadores de miles
  return '$' + intValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// Formatea un número con separadores de miles sin símbolo de moneda
export const formatNumber = (value) => {
  if (value === null || value === undefined || isNaN(value)) return '0';
  
  // Convierte a número entero (sin decimales)
  const intValue = Math.round(Number(value));
  
  // Agrega separadores de miles
  return intValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// Parsea un string con formato de número a número
export const parseFormattedNumber = (value) => {
  if (!value) return 0;
  
  // Remueve el símbolo de moneda y las comas
  const cleanValue = value.toString().replace(/[$,]/g, '');
  
  return parseFloat(cleanValue) || 0;
};

// Formatea un input mientras el usuario escribe
export const formatInputNumber = (value) => {
  // Remueve todo lo que no sea número
  const numbers = value.replace(/\D/g, '');
  
  if (!numbers) return '';
  
  // Convierte a número y agrega separadores de miles
  const formatted = parseInt(numbers).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  return formatted;
};